/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_OrganizerInputs */

const es_chat_tool_detail_organizer = /** @type {(inputs: Chat_Tool_Detail_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizador`)
};

const en_chat_tool_detail_organizer = /** @type {(inputs: Chat_Tool_Detail_OrganizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizer`)
};

/**
* | output |
* | --- |
* | "Organizer" |
*
* @param {Chat_Tool_Detail_OrganizerInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_organizer = /** @type {((inputs?: Chat_Tool_Detail_OrganizerInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_OrganizerInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_organizer(inputs)
	return en_chat_tool_detail_organizer(inputs)
});
export { chat_tool_detail_organizer as "chat.tool_detail.organizer" }